var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.Login),_c('el-dialog',{attrs:{"title":_setup.gameStore.exchangeGame.name+' - 游戏兑换',"width":"780px","visible":_setup.exchangeDialogVisible},on:{"update:visible":function($event){_setup.exchangeDialogVisible=$event}}},[_c(_setup.Exchange,{attrs:{"page-position":"publicPage"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }